<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-page-header title="显示配置" sub-title="Basic information">
        <a-row :gutter="10">
          <a-col :span="12" v-for="(item, index) in form.attrParam" :key="index">
            <a-form-model-item :label="paramMap[index]" :prop="index">
              <a-switch v-model="form.attrParam[index]" />
              <!-- <cy-custom-switch :check.sync="form.attrParam[index]" /> -->
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
    <userForm ref="userForm" @ok="getCustomList"></userForm>
    <pipelineForm ref="pipelineForm" @ok="getPipelineList"></pipelineForm>
    <typeFrom ref="typeFrom" @ok="getInterferenceTypeList"></typeFrom>
    <deviceCategorize ref="deviceCategorize" @ok="getDeviceCategorizeList"></deviceCategorize>
    <deviceType ref="deviceType" @ok="getDeviceTypeList"></deviceType>
  </a-drawer>
</template>

<script>
import { getConfigList, pubObj } from '../api'
import userForm from '../../../biz/user/modules/CreateForm.vue'
import pipelineForm from '../../pipeline/modules/CreateForm.vue'
import typeFrom from '../../interferencetype/modules/CreateForm.vue'
import deviceCategorize from '../../devicecategorize/modules/CreateForm.vue'
import deviceType from '../../devicetype/modules/CreateForm.vue'
import CyCustomSwitch from '@/components/CyCustomSwitch'
export default {
  name: 'ConfigForm',
  props: {},
  components: {
    userForm,
    pipelineForm,
    typeFrom,
    deviceCategorize,
    deviceType,
    CyCustomSwitch
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      pipelineList: [],
      customList: [],
      deviceCategorizeList: [],
      deviceTypeList: [],
      interferenceTypeList: [],
      // 表单参数
      form: {
        deviceId: '',
        attrParam: {
          acCurrentFlowingThroughTheTestPieceDensityShow: true,
          acCurrentFlowingThroughTheTestPieceShow: true,
          acInterferenceVoltageShow: true,
          batteryLevelShow: true,
          batteryVoltageShow: true,
          directCurrentFlowingThroughTheTestPieceDensityShow: true,
          directCurrentFlowingThroughTheTestPieceShow: true,
          electrifiedPotentialShow: true,
          sacrificialAnodeShow: true,
          sacrificialAnodeVoltageShow: true,
          selfCorrosionPotentialShow: true,
          signalStrengthShow: true,
          voffShow: true
        }
      },
      paramMap: {
        acCurrentFlowingThroughTheTestPieceDensityShow: '流经试片交流电流密度（A / m²）',
        acCurrentFlowingThroughTheTestPieceShow: '流经试片交流电流（mA）',
        acInterferenceVoltageShow: '交流干扰电压（v / vrms）',
        batteryLevelShow: '剩余电量（%）',
        batteryVoltageShow: '电池电压（V）',
        directCurrentFlowingThroughTheTestPieceDensityShow: '流经试片直流电流密度（mA / cm²）',
        directCurrentFlowingThroughTheTestPieceShow: '流经试片直流电流（mA）',
        electrifiedPotentialShow: '通电电位（V）',
        sacrificialAnodeShow: '牺牲阳极（mA）',
        sacrificialAnodeVoltageShow: '牺牲阳极（V）',
        selfCorrosionPotentialShow: '自腐蚀电位（V）',
        signalStrengthShow: '信号强度（%）',
        voffShow: '断电电位（V）'
      },

      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceName: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
        phoneNumber: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur'
          }
        ],
        locationDescription: [{ required: true, message: '请输入位置描述', trigger: 'blur' }],
        deviceCode: [{ required: true, message: '设备编号不能为空', trigger: 'blur' }],
        deviceCategorizeId: [{ required: true, message: '设备分类不能为空', trigger: 'blur' }]
      }
    }
  },
  filters: {},
  created() {
    // this.getPipelineList()
    // this.getDeviceCategorizeList()
    // this.getDeviceTypeList()
    // this.getInterferenceTypeList()
    // this.getCustomList(null)
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        deviceId: '',
        attrParam: {
          acCurrentFlowingThroughTheTestPieceDensityShow: true,
          acCurrentFlowingThroughTheTestPieceShow: true,
          acInterferenceVoltageShow: true,
          batteryLevelShow: true,
          batteryVoltageShow: true,
          directCurrentFlowingThroughTheTestPieceDensityShow: true,
          directCurrentFlowingThroughTheTestPieceShow: true,
          electrifiedPotentialShow: true,
          sacrificialAnodeShow: true,
          sacrificialAnodeVoltageShow: true,
          selfCorrosionPotentialShow: true,
          signalStrengthShow: true,
          voffShow: true
        }
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd(id) {
      this.reset()
      if (id) this.form.deviceId = id
      getConfigList({ deviceId: id }).then((res) => {
        console.log(res, '显示配置')
        this.form.deviceId = res.data.deviceId
        for (const key in this.form.attrParam) {
          this.form.attrParam[key] = res.data.attrParam[key] === 1
        }
      })
      this.formType = 1
      this.open = true
      this.formTitle = '显示配置'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDevice({ id: id }).then((response) => {
        this.form.deviceId = response.data.deviceId
        for (const key in this.form.attrParam) {
          this.form.attrParam[key] = response.data.attrParam[key] === 1
        }
        this.open = true
        this.formTitle = '显示配置'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const formAttrParam = JSON.parse(JSON.stringify(this.form.attrParam))
          for (const key in formAttrParam) {
            formAttrParam[key] = formAttrParam[key] ? 1 : 0
          }
          pubObj({ ...this.form, attrParam: formAttrParam })
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    },

    getDeviceCategorizeList() {
      listDeviceCategorize().then((response) => {
        this.deviceCategorizeList = response.data
      })
    },
    getDeviceTypeList() {
      listDeviceType().then((response) => {
        this.deviceTypeList = response.data
      })
    },
    getInterferenceTypeList() {
      listInterferenceType().then((response) => {
        this.interferenceTypeList = response.data
      })
    },
    getPipelineList() {
      let query = {
        pageNum: 1,
        pageSize: 1
      }
      listPipeline(query).then((response) => {
        this.pipelineList = response.data
      })
    },
    pipelineIdChange(value) {
      this.getCustomList(value)
      this.form.customUserId = undefined
    },
    getCustomList(pipelineId) {
      let query = {
        pipelineId: pipelineId,
        pageNum: 1,
        pageSize: 9999,
        userType: '04'
      }
      customList(query).then((response) => {
        this.customList = response.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
<style lang="less" scoped>
.ant-page-header {
  display: block !important;
}

.customUser_id {
  display: flex;
  align-items: center;

  .customUser_t {
    font-size: 20px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
